module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_39.02eceac8.png";